import { c as _c } from "react/compiler-runtime";
import { useChains } from "@opensea/app-kit";
import { Badge, DropdownItem, DropdownItemAvatar, DropdownItemContent, DropdownItemTitle, FlexCenter, FlexColumn, FormControl, formatAddress, ItemAvatar, ItemContent, ItemDescription, ItemSide, ItemTitle, Label, Select, SelectItem, SelectItemAvatar, SelectItemContent, SelectItemTitle, TextBody, Tooltip } from "@opensea/ui-kit";
import { Add, Wallet } from "@opensea/ui-kit/icons";
import { isAddressEqual } from "@opensea/utils";
import { useCallback, useEffect, useState } from "react";
import { useTranslations } from "use-intl";
import { useDestinationWallets, useGetDestinationWallet } from "../../flow/SideSheetFlows/SwapFlow/components/SwapDestination/useDestinationWallets";
import { getChainArchFromAddress, isAddress } from "../../lib/address";
import { isAbstractWalletAccount } from "../../lib/wagmi/helpers";
import { useAddress, useConnectors } from "../../polychain/hooks";
import { CustomDestinationWalletsActions } from "../../stores/customDestinationWalletsStore";
import { Avatar } from "../Avatar";
import { Button } from "../Button";
import { Item } from "../Item";
import { DestinationWalletSelectModal } from "./DestinationWalletSelectModal";
export const DestinationWalletSelect = t0 => {
  const $ = _c(90);
  const {
    label,
    destinationChain,
    onWalletSelect,
    walletDestination,
    error,
    className
  } = t0;
  const t = useTranslations("wallet.DestinationWalletSelect");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const currentAddress = useAddress();
  const {
    getChain
  } = useChains();
  const destinationWallets = useDestinationWallets();
  const getDestinationWallet = useGetDestinationWallet();
  const getAvatarProps = useGetAvatarProps();
  let t1;
  if ($[0] !== destinationChain || $[1] !== getChain) {
    t1 = destinationChain ? getChain(destinationChain) : undefined;
    $[0] = destinationChain;
    $[1] = getChain;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const destinationChainData = t1;
  let t2;
  if ($[3] !== destinationChainData?.arch || $[4] !== destinationChainData?.identifier || $[5] !== destinationWallets || $[6] !== walletDestination?.address) {
    let t3;
    if ($[8] !== walletDestination?.address) {
      t3 = wallet => !isAddressEqual(wallet.address, walletDestination?.address);
      $[8] = walletDestination?.address;
      $[9] = t3;
    } else {
      t3 = $[9];
    }
    let t4;
    if ($[10] !== destinationChainData?.arch) {
      t4 = account => destinationChainData?.arch === getChainArchFromAddress(account.address);
      $[10] = destinationChainData?.arch;
      $[11] = t4;
    } else {
      t4 = $[11];
    }
    let t5;
    if ($[12] !== destinationChainData?.identifier) {
      t5 = wallet_0 => {
        const isAbstract = isAbstractWalletAccount(wallet_0.connectorId ?? "");
        if (isAbstract) {
          return destinationChainData?.identifier === "abstract";
        }
        return true;
      };
      $[12] = destinationChainData?.identifier;
      $[13] = t5;
    } else {
      t5 = $[13];
    }
    t2 = destinationWallets.filter(t3).filter(t4).filter(t5);
    $[3] = destinationChainData?.arch;
    $[4] = destinationChainData?.identifier;
    $[5] = destinationWallets;
    $[6] = walletDestination?.address;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  const validDestinationWallets = t2;
  let t3;
  if ($[14] !== onWalletSelect) {
    t3 = value => {
      const selectedWallet = {
        address: value,
        identifier: value
      };
      onWalletSelect(selectedWallet);
      CustomDestinationWalletsActions.setLastSelectedWallet(selectedWallet);
    };
    $[14] = onWalletSelect;
    $[15] = t3;
  } else {
    t3 = $[15];
  }
  const onValueChange = t3;
  const onDeleteCustomWallet = _temp;
  let t4;
  if ($[16] !== onWalletSelect) {
    t4 = wallet_1 => {
      onWalletSelect(wallet_1);
      CustomDestinationWalletsActions.setLastSelectedWallet(wallet_1);
      setIsModalOpen(false);
    };
    $[16] = onWalletSelect;
    $[17] = t4;
  } else {
    t4 = $[17];
  }
  const handleModalWalletSelect = t4;
  let t5;
  if ($[18] !== destinationChainData || $[19] !== onWalletSelect || $[20] !== walletDestination) {
    t5 = function resetRecipientWhenIncompatibleWithDestinationCurrency() {
      if (walletDestination?.address) {
        const chainArch = getChainArchFromAddress(walletDestination.address);
        if (destinationChainData && chainArch !== destinationChainData.arch) {
          onWalletSelect({
            address: ""
          });
        }
      }
    };
    $[18] = destinationChainData;
    $[19] = onWalletSelect;
    $[20] = walletDestination;
    $[21] = t5;
  } else {
    t5 = $[21];
  }
  const t6 = walletDestination?.address;
  let t7;
  if ($[22] !== destinationChainData || $[23] !== onWalletSelect || $[24] !== t6) {
    t7 = [destinationChainData, t6, onWalletSelect];
    $[22] = destinationChainData;
    $[23] = onWalletSelect;
    $[24] = t6;
    $[25] = t7;
  } else {
    t7 = $[25];
  }
  useEffect(t5, t7);
  let t8;
  if ($[26] !== currentAddress || $[27] !== onValueChange || $[28] !== validDestinationWallets || $[29] !== walletDestination?.identifier) {
    t8 = () => {
      const defaultDestinationWallet = validDestinationWallets.find(wallet_2 => isAddressEqual(wallet_2.address, currentAddress)) || validDestinationWallets.at(0);
      if (!walletDestination?.identifier && defaultDestinationWallet) {
        onValueChange(defaultDestinationWallet.address);
      }
    };
    $[26] = currentAddress;
    $[27] = onValueChange;
    $[28] = validDestinationWallets;
    $[29] = walletDestination?.identifier;
    $[30] = t8;
  } else {
    t8 = $[30];
  }
  let t9;
  if ($[31] !== currentAddress || $[32] !== onValueChange || $[33] !== validDestinationWallets || $[34] !== walletDestination) {
    t9 = [validDestinationWallets, walletDestination, onValueChange, currentAddress];
    $[31] = currentAddress;
    $[32] = onValueChange;
    $[33] = validDestinationWallets;
    $[34] = walletDestination;
    $[35] = t9;
  } else {
    t9 = $[35];
  }
  useEffect(t8, t9);
  let t10;
  if ($[36] !== label || $[37] !== t) {
    t10 = label ? label : <Label size="sm" weight="regular">{t("destinationWallet")}</Label>;
    $[36] = label;
    $[37] = t;
    $[38] = t10;
  } else {
    t10 = $[38];
  }
  let t11;
  if ($[39] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <Avatar border={true} className="p-1" icon={Wallet} overrides={{
      Icon: {
        fill: "text-secondary"
      }
    }} rounded={true} size={24} />;
    $[39] = t11;
  } else {
    t11 = $[39];
  }
  let t12;
  if ($[40] !== t) {
    t12 = t("selectWallet");
    $[40] = t;
    $[41] = t12;
  } else {
    t12 = $[41];
  }
  let t13;
  if ($[42] !== t12) {
    t13 = <FlexCenter className="gap-2">{t11}<TextBody color="text-secondary">{t12}</TextBody></FlexCenter>;
    $[42] = t12;
    $[43] = t13;
  } else {
    t13 = $[43];
  }
  let t14;
  if ($[44] !== currentAddress || $[45] !== getAvatarProps || $[46] !== getDestinationWallet || $[47] !== t) {
    t14 = value_0 => {
      const destinationWallet = getDestinationWallet(value_0);
      const address_0 = destinationWallet?.address ?? value_0;
      const identifier = destinationWallet?.identifier ?? value_0;
      return <Item key={address_0} variant="unstyled"><ItemAvatar {...getAvatarProps(destinationWallet?.connectorId)} size={24} /><ItemContent><Tooltip content={address_0}><ItemTitle>{isAddress(identifier) ? formatAddress(identifier) : identifier}</ItemTitle></Tooltip></ItemContent>{isAddressEqual(currentAddress, address_0) && <ItemSide><Badge>{t("connected")}</Badge></ItemSide>}</Item>;
    };
    $[44] = currentAddress;
    $[45] = getAvatarProps;
    $[46] = getDestinationWallet;
    $[47] = t;
    $[48] = t14;
  } else {
    t14 = $[48];
  }
  const t15 = walletDestination?.identifier;
  let t16;
  if ($[49] !== t || $[50] !== validDestinationWallets.length) {
    t16 = validDestinationWallets.length > 0 && <Item className="px-2 py-1" variant="unstyled"><ItemContent><ItemDescription weight="regular">{t("recentWallets")}</ItemDescription></ItemContent></Item>;
    $[49] = t;
    $[50] = validDestinationWallets.length;
    $[51] = t16;
  } else {
    t16 = $[51];
  }
  let t17;
  if ($[52] !== currentAddress || $[53] !== getAvatarProps || $[54] !== t || $[55] !== validDestinationWallets) {
    let t18;
    if ($[57] !== currentAddress || $[58] !== getAvatarProps || $[59] !== t) {
      t18 = wallet_3 => {
        const isCustom = !wallet_3.connectorId;
        return <SelectItem key={wallet_3.address} value={wallet_3.address}><SelectItemAvatar {...getAvatarProps(wallet_3.connectorId)} size={24} /><SelectItemContent><SelectItemTitle>{isAddress(wallet_3.identifier) ? formatAddress(wallet_3.identifier) : wallet_3.identifier}</SelectItemTitle></SelectItemContent>{isAddressEqual(currentAddress, wallet_3.address) && <ItemSide><Badge>{t("connected")}</Badge></ItemSide>}{isCustom && <ItemSide><Button onClick={e => onDeleteCustomWallet(e, wallet_3.address)} size="xs" variant="destructive">{t("delete")}</Button></ItemSide>}</SelectItem>;
      };
      $[57] = currentAddress;
      $[58] = getAvatarProps;
      $[59] = t;
      $[60] = t18;
    } else {
      t18 = $[60];
    }
    t17 = validDestinationWallets.map(t18);
    $[52] = currentAddress;
    $[53] = getAvatarProps;
    $[54] = t;
    $[55] = validDestinationWallets;
    $[56] = t17;
  } else {
    t17 = $[56];
  }
  let t18;
  let t19;
  if ($[61] === Symbol.for("react.memo_cache_sentinel")) {
    t18 = () => setIsModalOpen(true);
    t19 = <DropdownItemAvatar icon={Add} size={24} />;
    $[61] = t18;
    $[62] = t19;
  } else {
    t18 = $[61];
    t19 = $[62];
  }
  let t20;
  if ($[63] !== t) {
    t20 = t("addWallet");
    $[63] = t;
    $[64] = t20;
  } else {
    t20 = $[64];
  }
  let t21;
  if ($[65] !== t20) {
    t21 = <DropdownItem onClick={t18}>{t19}<DropdownItemContent><DropdownItemTitle>{t20}</DropdownItemTitle></DropdownItemContent></DropdownItem>;
    $[65] = t20;
    $[66] = t21;
  } else {
    t21 = $[66];
  }
  let t22;
  if ($[67] !== t16 || $[68] !== t17 || $[69] !== t21) {
    t22 = <FlexColumn className="gap-1">{t16}{t17}{t21}</FlexColumn>;
    $[67] = t16;
    $[68] = t17;
    $[69] = t21;
    $[70] = t22;
  } else {
    t22 = $[70];
  }
  let t23;
  if ($[71] !== onValueChange || $[72] !== t13 || $[73] !== t14 || $[74] !== t15 || $[75] !== t22) {
    t23 = <Select className="px-2" onValueChange={onValueChange} placeholder={t13} renderValue={t14} size="md" value={t15} variant="transparent">{t22}</Select>;
    $[71] = onValueChange;
    $[72] = t13;
    $[73] = t14;
    $[74] = t15;
    $[75] = t22;
    $[76] = t23;
  } else {
    t23 = $[76];
  }
  let t24;
  if ($[77] !== className || $[78] !== error || $[79] !== t10 || $[80] !== t23) {
    t24 = <FormControl className={className} error={error} label={t10}>{t23}</FormControl>;
    $[77] = className;
    $[78] = error;
    $[79] = t10;
    $[80] = t23;
    $[81] = t24;
  } else {
    t24 = $[81];
  }
  const t25 = destinationChainData?.arch;
  let t26;
  if ($[82] === Symbol.for("react.memo_cache_sentinel")) {
    t26 = () => setIsModalOpen(false);
    $[82] = t26;
  } else {
    t26 = $[82];
  }
  let t27;
  if ($[83] !== handleModalWalletSelect || $[84] !== isModalOpen || $[85] !== t25) {
    t27 = <DestinationWalletSelectModal chainArch={t25} onClose={t26} onWalletSelect={handleModalWalletSelect} open={isModalOpen} />;
    $[83] = handleModalWalletSelect;
    $[84] = isModalOpen;
    $[85] = t25;
    $[86] = t27;
  } else {
    t27 = $[86];
  }
  let t28;
  if ($[87] !== t24 || $[88] !== t27) {
    t28 = <>{t24}{t27}</>;
    $[87] = t24;
    $[88] = t27;
    $[89] = t28;
  } else {
    t28 = $[89];
  }
  return t28;
};
function useGetAvatarProps() {
  const $ = _c(2);
  const {
    getConnector
  } = useConnectors();
  let t0;
  if ($[0] !== getConnector) {
    t0 = connectorId => {
      if (connectorId) {
        const connector = getConnector(connectorId);
        return connector?.icon ? {
          src: connector.icon
        } : {
          icon: Wallet
        };
      }
      return {
        icon: Wallet
      };
    };
    $[0] = getConnector;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const avatarProps = t0;
  return avatarProps;
}
function _temp(event, address) {
  event.stopPropagation();
  CustomDestinationWalletsActions.deleteDestinationWallet(address);
}